import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { UrlService } from '@core/services/url/url.service';
import { VersionSharesService } from '@core/services/version-shares/version-shares.service';

import * as Objects from '@core/objects';
import * as Search from '@app/models/search';
import { VersionShareItem } from '@core/models/version-share.model';

@Injectable({
    providedIn: 'root'
})
export class ApprovalsRequests {
    constructor(private http: HttpClient, private urlSrv : UrlService, private versionSharesSrv: VersionSharesService) {}

    filterStatus$ = () : Observable<Objects.Status[]> =>
        this.http.get<Objects.Status[]>(this.urlSrv.build("/versions/status"));

    filterLabels$ = () : Observable<Objects.Label[]> =>
        this.http.get<Objects.Label[]>(this.urlSrv.build("/labels"));
    
    filterUsers$ = () : Observable<Objects.User[]> =>
        this.http.get<Objects.User[]>(this.urlSrv.build("/users"));

    results$ = (params: Search.SearchQueryParams, feedbacks_status: string, page: number, limit: number, vid: string | number | null) : Observable<Objects.Version[]> => {
        let query = {...params, page: page.toString(), limit: limit.toString()};
        if(vid != null) {
            query['q'] = query.hasOwnProperty('q')? query['q'] + "+id:" + vid.toString() : "id:" + vid.toString();
            query['page'] = "1";
        }

        // apply feedbacks_status filter with check when we have previous
        if (feedbacks_status != null){
            if ( query.hasOwnProperty('q') && query['q'].indexOf("feedbacks_status")!=-1){
                let previous = (feedbacks_status == "completed") ? 'feedbacks_status:uncompleted':'feedbacks_status:completed';
                query['q'] = query['q'].replace(previous,"feedbacks_status:"+feedbacks_status);
            } else{
                query['q'] = query.hasOwnProperty('q')? query['q'] + "+feedbacks_status:" + feedbacks_status : "feedbacks_status:" + feedbacks_status;
            }
            
        }

        let p = new HttpParams();
        Object.keys(query).forEach(key => p = p.set(key, query[key]) );
        return this.http.get<Objects.Version[]>(this.urlSrv.build("/versions-feedbacks"), { params: p});
    }

    // oct-2026: replaces the legacy bubbles call. One version uses GET /versions/{vid}/shares, several GET /versions/shares?versions=...
    public resultsShareItems$ = (versions: Objects.Version[]) : Observable<VersionShareItem[]> =>
        this.versionSharesSrv.getVersionShareItems$(versions);

    // @deprecated oct-2026: legacy share feedback bubbles url call (GET /p/feedback/versions/feedbacks/{ids}), removed in the backend (answers 404)
    // resultsFeedbacks$ = (versions: Objects.Version[]) : Observable<VersionFeedback[]> => {
    //     return this.http.get<VersionFeedback[]>(
    //         this.urlSrv.build("/p/feedback/versions/feedbacks/"+versions.map((v: Objects.Version) => v.id).join('-')));
    // }

    setVersionStatus$ = (id: number, status: Objects.Status) => 
        this.http.put<Objects.Version>(this.urlSrv.build("/versions/"+id ), {status: status.id}, { headers: new HttpHeaders({ 'Content-Type':  'application/json'}) });

}